import cx from 'classnames';
import { MessageDescriptor, useIntl } from 'react-intl';

import { IntrinsicElement } from '../../../../shared/utilities/types/IntrinsicElement';
import { Typography } from '../../typography/Typography';

import style from './AgencyTag.module.css';

type AgencyTagProps = {
    area: number;
    titleElement?: IntrinsicElement;
    reversed?: boolean;
};

export function AgencyTag({ area, titleElement, reversed = false }: AgencyTagProps) {
    const { formatMessage } = useIntl();

    return (
        <Typography
            as={titleElement}
            className={cx(style.tag, {
                [style.reversed]: reversed,
                [style.default]: !reversed,
            })}
            scale="primary-xs-bold"
        >
            {formatMessage({
                id: `page.agency.expertise-${area}` as MessageDescriptor['id'],
            })}
        </Typography>
    );
}
